var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "iconColor",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.5C27.8807 12.5 29 11.3807 29 10C29 8.61929 27.8807 7.5 26.5 7.5C25.1193 7.5 24 8.61929 24 10C24 11.3807 25.1193 12.5 26.5 12.5Z",
    stroke: "#12428A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.3782V6C11 4.93913 11.4214 3.92172 12.1716 3.17157C12.9217 2.42143 13.9391 2 15 2C16.0609 2 17.0783 2.42143 17.8284 3.17157C18.5786 3.92172 19 4.93913 19 6V18.3782L19.001 18.3769C20.0676 19.21 20.8476 20.3552 21.2321 21.6528C21.6166 22.9504 21.5866 24.3357 21.146 25.6153C20.7055 26.895 19.8766 28.0053 18.7748 28.7912C17.673 29.5772 16.3534 29.9996 15 29.9996C13.6466 29.9996 12.327 29.5772 11.2252 28.7912C10.1234 28.0053 9.29448 26.895 8.85396 25.6153C8.41345 24.3357 8.38336 22.9504 8.76789 21.6528C9.15243 20.3552 9.93241 19.21 10.999 18.3769L11 18.3782Z",
    stroke: "#12428A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26C16.3807 26 17.5 24.8807 17.5 23.5C17.5 22.1193 16.3807 21 15 21C13.6193 21 12.5 22.1193 12.5 23.5C12.5 24.8807 13.6193 26 15 26Z",
    stroke: "#12428A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21V11",
    stroke: "#12428A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.6431f341.svg";
export { ForwardRef as ReactComponent };